"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productsTableQueryStateDefaults = void 0;
const view_query_params_1 = require("../../../../../common/view-query-params");
const products_table_1 = require("../../../../../store/catalogs/products-table");
exports.productsTableQueryStateDefaults = {
    [view_query_params_1.ViewQueryStateField.Filter]: products_table_1.defaultProductsTableState.filter,
    [view_query_params_1.ViewQueryStateField.Search]: products_table_1.defaultProductsTableState.search,
    [view_query_params_1.ViewQueryStateField.Sort]: products_table_1.defaultProductsTableState.sort,
    [view_query_params_1.ViewQueryStateField.PageSize]: products_table_1.defaultProductsTableState.pageSize,
    [view_query_params_1.ViewQueryStateField.DynamicColumns]: products_table_1.defaultProductsTableState.dynamicColumns,
    [view_query_params_1.ViewQueryStateField.MiddleSectionFilter]: null,
};
